import(/* webpackMode: "eager" */ "/app/src/components/leaderboard/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/layouts/Wrapper.tsx")